// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Dataset } from "./Dataset";
import { instanceOfDataset, DatasetFromJSON, DatasetFromJSONTyped, DatasetToJSON } from "./Dataset";
import type { RanaFile } from "./RanaFile";
import {
  instanceOfRanaFile,
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
} from "./RanaFile";

/**
 * @type Create2dFloodModelInputFriction
 *
 * @export
 */
export type Create2dFloodModelInputFriction = Dataset | RanaFile;

export function Create2dFloodModelInputFrictionFromJSON(
  json: any
): Create2dFloodModelInputFriction {
  return Create2dFloodModelInputFrictionFromJSONTyped(json, false);
}

export function Create2dFloodModelInputFrictionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Create2dFloodModelInputFriction {
  if (json == null) {
    return json;
  }
  if (typeof json !== "object") {
    return json;
  }
  if (instanceOfDataset(json)) {
    return DatasetFromJSONTyped(json, true);
  }
  if (instanceOfRanaFile(json)) {
    return RanaFileFromJSONTyped(json, true);
  }
  return {} as any;
}

export function Create2dFloodModelInputFrictionToJSON(json: any): any {
  return Create2dFloodModelInputFrictionToJSONTyped(json, false);
}

export function Create2dFloodModelInputFrictionToJSONTyped(
  value?: Create2dFloodModelInputFriction | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value !== "object") {
    return value;
  }
  if (instanceOfDataset(value)) {
    return DatasetToJSON(value as Dataset);
  }
  if (instanceOfRanaFile(value)) {
    return RanaFileToJSON(value as RanaFile);
  }
  return {};
}
